import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom/dist";
import { HOME_PAGE } from "./common/constants/routerConstants";
import { getRoles } from "./common/utils/FunctionsUtils";
import globalRouter from "./common/utils/globalRouter";
import withTokenValidation from "./common/utils/withTokenValidation";
import Auth from "./modules/home/ui/Auth";
import Home from "./modules/home/ui/Home";
import { SnackbarProvider } from "notistack";
import ResetPassword from "./common/components/ResetPassword";

const theme = createTheme({
  palette: {
    primary: {
      main: "#25384a",
    },
    secondary: {
      main: "#25384a",
    },
  },
});

export const ModuleName = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  return queryParameters.get("module");
};

function App() {
  const [forbidden, setForbidden] = useState(false);
  const providerRef = useRef();

  const roles = getRoles();
  const isAuthenticated = !!localStorage.getItem("token");

  useEffect(() => {
    if (isAuthenticated && typeof window.startWidget === "function") {
      window.startWidget({});
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    let token = queryParameters.get("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (
          decoded.roles?.includes("ROLE_VUPORTUARIA_BANCO") ||
          decoded.roles?.includes("ROLE_VUPORTUARIA_ADMIN") ||
          decoded.roles?.includes("ROLE_VUPORTUARIA_ANP")
        ) {
          localStorage.setItem("token", token);
          navigate(HOME_PAGE);
        }
      } catch (err) {}
    }
  }, []);

  const navigate = useNavigate();
  globalRouter.navigate = navigate;
  return (
    <SnackbarProvider maxSnack={3} ref={providerRef}>
      <ThemeProvider theme={theme}>
        {!isAuthenticated ? (
          <Routes>
            <Route path="/" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        ) : (
          <Home roles={roles} />
        )}
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default withTokenValidation(App, ModuleName());
